<template>
    <router-view></router-view>
</template>

<script>
export default {
    data() {
      return {
        projectId: null,
      }
    },
    created() {
        let projectId = this.$route.params.projectId;
        this.projectId = projectId;
        this.$store.dispatch('projects/loadProjectById', { projectId });
        this.$store.dispatch('system/loadGlobalConfiguration');
    },

    updated() {
        let projectId = this.$route.params.projectId;
        if (projectId && projectId !== this.projectId) {
            this.$store.dispatch('projects/loadProjectById', { projectId });
        }
    },
}
</script>

